import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-checkbox',
  templateUrl: './formly-checkbox.component.html',
  styleUrls: ['./formly-checkbox.component.scss'],
})
export class FormlyCheckboxComponent extends FieldType {}
